import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_SESSION,
  DELETE_SESSION,
  DELETE_SESSION_RULE,
  GET_ALL_SESSION_LIST,
  GET_SESSION_DETAILS,
  UPDATE_SESSION,
  GET_SESSION_OF_FACILITY,
  VALIDATE_SESSION_BOOKING_ATTENDEE_USER,
  GET_AVAILABLE_SESSIONS,
  DELETE_FROM_DATABASE,
  SESSION_BOOKING_AMOUNT,
} from "../common/constant";

const GetSessionDetails = (id: any) => {
  return AxiosRequest.get(GET_SESSION_DETAILS.replace(":id", id));
};

const GetSessionList = (facilityId: string) => {
  return AxiosRequest.get(GET_ALL_SESSION_LIST(facilityId));
};

const GetAvailableSessions = (
  facilityId: string,
  sportId: string,
  noOfDays: string
) => {
  return AxiosRequest.get(
    GET_AVAILABLE_SESSIONS(facilityId, sportId, noOfDays)
  );
};

const CreateNewSession = (payload: any) => {
  return AxiosRequest.post(CREATE_SESSION, payload);
};

const UpdateSession = (id: string, payload: any) => {
  return AxiosRequest.put(UPDATE_SESSION.replace(":id", id), payload);
};

const DeleteSession = (id: string) => {
  return AxiosRequest.delete(DELETE_SESSION.replace(":id", id));
};

const DeleteSessionRule = (id: string, rule: string) => {
  return AxiosRequest.delete(
    DELETE_SESSION_RULE.replace(":id", id).replace(":rule", rule)
  );
};

const GetSessionForFacility = (id: string) => {
  return AxiosRequest.get(GET_SESSION_OF_FACILITY(id));
};

const ValidateSessionBookingAttendeeUser = (payload: any) => {
  return AxiosRequest.post(VALIDATE_SESSION_BOOKING_ATTENDEE_USER, payload);
};

const DeleteFromDatabase = (
  type: string,
  sessionId: string,
  typeId: string
) => {
  return AxiosRequest.delete(
    DELETE_FROM_DATABASE.replace(":type", type)
      .replace(":sessionId", sessionId)
      .replace(":typeId", typeId)
  );
};

const SessionBookingAmount = (payload: any) => {
  return AxiosRequest.post(SESSION_BOOKING_AMOUNT, payload);
};
export {
  GetSessionList,
  CreateNewSession,
  GetSessionDetails,
  UpdateSession,
  DeleteSession,
  DeleteSessionRule,
  GetSessionForFacility,
  ValidateSessionBookingAttendeeUser,
  GetAvailableSessions,
  DeleteFromDatabase,
  SessionBookingAmount,
};
